/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//充电管理
const chargeLayout = require('appComp/page/charge/charge-layout/charge-layout');
const siteLists = require('appComp/page/charge/site-lists/site-lists');
const siteDetails = require('appComp/page/charge/site-details/site-details');
const siteComment = require('appComp/page/charge/site-comment/site-comment');

const orderList = require('appComp/page/charge/order-list/order-list');
const orderDetail = require('appComp/page/charge/order-detail/order-detail');

const intelligentSort = require('appComp/page/charge/intelligent-sort/intelligent-sort');

module.exports = {
	"component": chargeLayout,
	"subRoutes": {
		"/siteLists": {
			"title": "充电站列表",
			"component": chargeLayout,
			"subRoutes": {
				"/": {
		          "component": siteLists,
		          "name": "site-lists"
		        },
		        "detail": {
		        	"title": "站点详情",
		        	"component": chargeLayout,
		        	"subRoutes": {
		        		"/": {
							"component": siteDetails,
							"name": "site-details"
		        		},
		        		"comment": {
		        			"title": "发表点评",
		        			"component": siteComment,
		        			"name": "site-comment"
		        		}
		        	}
		        }
			}
		},
		"/order": {
			"title": "充电订单",
			"component": chargeLayout,
			"subRoutes": {
				"/": {
		            "component": orderList,
		            "name": "order-list"
		        },
		        "detail": {
		        	"title": "订单详情",
		            "component": orderDetail,
		            "name": "order-detail"
		        }
			}
		},
		"/intelSort": {
			"title": "智能排序",
			"component": chargeLayout,
			"subRoutes": {
				"/": {
		            "component": intelligentSort,
		            "name": "intelligent-sort"
		        }
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/appBackend/router/charge.js